<script>
    import { onMount } from "svelte";
    import { createEventDispatcher } from 'svelte';
    import { LocationStore, Authentication } from '../stores'
    
    const dispatch = createEventDispatcher();

    let value;
    let shown = false;
    let modalStep = 0;
    let nextButtonDisabled = true;
    let okButtonDisabled = true;
    let authenthicationData = '';
    let locationsDropDown = [{ id: "0", text: "Loading ..." }];
    let locationsDropDownSelected;
    let orderableCheese = [];
    let locationPositions = [];

    onMount(async function () {
        loadLocations();
    });

    async function loadLocations() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/location';

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        // Put the data in the store
        LocationStore.set(data);

        var arrayLength = data.length;
        if(arrayLength > 0) {
            locationsDropDown = [];
            for (var i = 0; i < arrayLength; i++) {
                locationsDropDown.push({id: data[i].id, text: data[i].name});
            }
        }
    }

    async function loadMovableCheese() {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/OrderableCheese/' + locationsDropDownSelected.id;

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();
        orderableCheese = data;

        var arrayLength = orderableCheese.length;
        for (var i = 0; i < arrayLength; i++) {
            orderableCheese[i].selectable = true;
        }
    }

    export function show() {
        orderableCheese = [];
        locationPositions = [];
        locationsDropDownSelected = '';
        modalStep = 0;
        nextButtonDisabled = true;
        okButtonDisabled = true;
        shown = true;
    }
    function hide() {
        shown = false;
    }
    
    function _onNextClick() {
        locationsDropDownSelected = '';
        modalStep += 1;
    }

    let onChange = () => {};

    async function _onOkay() {
        await Authentication.subscribe((data) => authenthicationData = data);

        let method = 'PUT';

        let newFloors = [];
        let newPositions = [];

        // First get new floor and new position
        var locationPositionLength = locationPositions.length;
        for (var i = 0; i < locationPositionLength; i++) {
            var positionLength = locationPositions[i].length;
            for (var j = 0; j < positionLength; j++) {
                if (locationPositions[i][j].selectable === true && locationPositions[i][j].inUse === true) {
                    newFloors.push(i + 1);
                    newPositions.push(j + 1);
                }
            }
        }

        // Check if really a floor and position could be determined
        if(newFloors.length === 0 || newFloors.length != newPositions.length) {
            return;
        }

        var updCheeseList = [];
        // Now get the orderable cheese
        var arrayLength = orderableCheese.length;
        var newCnt = 0;
        for (var i = 0; i < arrayLength; i++) {
            if(orderableCheese[i].selected == true) {
                orderableCheese[i].locationLevel = newFloors[newCnt];
                orderableCheese[i].locationLevelPosition = newPositions[newCnt];
                
                orderableCheese[i].locationId = locationsDropDownSelected.id;
                updCheeseList.push(orderableCheese[i]);
                newCnt += 1;
            }
        }
        
        const response = await fetch(
            'MYURL/CheeseList',
            {
                method: method,
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
                body: JSON.stringify(
                    updCheeseList
                )
            }
        );
        const data = await response.json();

        dispatch('accepted', {
            
        });

        _onCancel();
    }

    function orderableCheeseChanged(id) {
        var arrayLength = orderableCheese.length;
        
        /*// Manage single clickable item
        for (var i = 0; i < arrayLength; i++) {
            if(orderableCheese[i].id != id) {
                orderableCheese[i].selected = false;
            }
        }*/
        
        // Manage Next-Button
        for (var i = 0; i < arrayLength; i++) {
            if(orderableCheese[i].selected == true) {
                nextButtonDisabled = false;
                return;
            }
        }

        nextButtonDisabled = true;
    }
    
    function _onCancel() {
        hide();
    }

    function _showMovablePositions() {
        loadMovableCheese();
    }

    async function _showDestinationPositions () {
        await Authentication.subscribe((data) => authenthicationData = data);
        let url = 'MYURL/Location_available/' + locationsDropDownSelected.id;

        const response = await fetch(
            url,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': authenthicationData
                },
            }
        );
        const data = await response.json();

        locationPositions = data;
    }

    function _locationPositionChanged(floor, position) {
        var locationPositionLength = locationPositions.length;
        let locationsSelectedCnt = 0;
        var orderableCheeseLength = orderableCheese.length;
        let orderablesSelectedCnt = 0;

        for (var i = 0; i < locationPositionLength; i++) {
            var positionLength = locationPositions[i].length;
            for (var j = 0; j < positionLength; j++) {
                if (locationPositions[i][j].selectable === true) {
                    if (locationPositions[i][j].inUse === true) {
                        locationsSelectedCnt += 1;
                    }
                }
            }
        }

        for (var i = 0; i < orderableCheeseLength; i++) {
            if(orderableCheese[i].selectable === true) {
                if(orderableCheese[i].selected === true) {
                    orderablesSelectedCnt += 1;
                }
            }
        }

        if(locationsSelectedCnt === orderablesSelectedCnt) {
            okButtonDisabled = false;
        } else {
            okButtonDisabled = true;
        }
    }
    
    function formatDate(date) {
        let the_date = new Date(date)
        let yyyy = the_date.getFullYear();
        let mm = the_date.getMonth() + 1; // Months start at 0!
        let dd = the_date.getDate();

        if (dd < 10) dd = '0' + dd;
        if (mm < 10) mm = '0' + mm;

        return dd + '/' + mm + '/' + yyyy;
    }

    $: onChange(value)
</script>

<svelte:window on:keydown={(e) => {
    if(e.keyCode == 27) {
        hide();
    }
}} />
{#if shown}
    <div class="orderMgt">
        <div class="modal">
            <span class="close" on:click={() => hide()}>&times</span>

            {#if modalStep === 0}
                <h1>Verschieben von</h1>
                <h2>Schrank und Käse auswählen</h2>
                <select class="textbox" bind:value={locationsDropDownSelected} on:change="{() => _showMovablePositions()}">
                    {#each locationsDropDown as locationsDropDownItem}
                        <option value={locationsDropDownItem}>
                            {locationsDropDownItem.text}
                        </option>
                    {/each}
                </select>
                <div class="wrapper">
                    {#each orderableCheese as cheese}
                        <label>
                            <input type=checkbox bind:checked={cheese.selected} disabled={!cheese.selectable} on:change={orderableCheeseChanged(cheese.id)}>
                            <div class="selection"><b>Etage:</b>&nbsp;{cheese.locationLevel}&nbsp;<b>Pos.:</b>&nbsp;{cheese.locationLevelPosition}&nbsp;<b>{cheese.cheeseType_Name}</b></div>
                            {#if cheese.is_Matured == true}
                                <div class="spaceToNext"><b style='color:red;'>Erstellung:</b>&nbsp;{formatDate(cheese.creationDate)}</div>
                            {:else}
                                <div class="spaceToNext"><b>Erstellung:</b>&nbsp;{formatDate(cheese.creationDate)}</div>
                            {/if}
                        </label>
                    {/each}
                </div>
            {:else}
                <h1>Verschieben nach</h1>
                <h2>Schrank und Position</h2>
                <select class="textbox" bind:value={locationsDropDownSelected} on:change="{() => _showDestinationPositions()}">
                    {#each locationsDropDown as locationsDropDownItem}
                        <option value={locationsDropDownItem}>
                            {locationsDropDownItem.text}
                        </option>
                    {/each}
                </select>
                <div class="wrapper">
                    {#each locationPositions as location, locationIndex}
                        {#each location as position, positionIndex}
                            <label>
                                <input type=checkbox bind:checked={position.inUse} disabled={!position.selectable} on:change={_locationPositionChanged((locationIndex + 1), position.pos)}>
                                Etage:&nbsp;{locationIndex + 1}&nbsp;Position:&nbsp;{positionIndex + 1}
                            </label>
                        {/each}
                    {/each}
                </div>
            {/if}
            
            <div>
                <div class="buttons">
                    {#if modalStep < 1}
                        <button disabled={nextButtonDisabled} on:click={() => _onNextClick()}>
                            Weiter
                        </button>
                    {:else}
                        <button disabled={okButtonDisabled} on:click={() => _onOkay()}>
                            Speichern
                        </button>
                    {/if}
                    <button on:click={() => _onCancel()}>
                        Abbrechen
                    </button>
                </div>
            </div>
        </div>
    </div>
{/if}


<style>
    .selection {
        display: inline-flex;
        justify-content: space-between;
    }

    .spaceToNext {
        margin-bottom: 10px;
    }

    .wrapper{
        padding:20px;
        max-height: 320px;
        overflow-y: scroll;
    }

    .textbox {
        padding-top: -10px;
        margin-top: -10px;
        min-width: 500px;
    }

    .buttons {
        float: right;
    }

    .wrapper{
        padding:20px;
        max-height: 320px;
        overflow-y: scroll;
    }

	.orderMgt {
	  background: rgb(0, 0, 0);
	  background: rgba(0, 0, 0, 0.6);
      position: fixed;
      width: 88%;
      height: 100%;
      top: 0;
      left: 0;

	  padding: 3rem 7.5rem;
	  display: flex;
	  flex-direction: column;
	}

    .modal {
        background-color: white;
        max-width: 80vw;
        padding: 1em;
        margin: -30px auto;
    }

    .close {
        cursor: pointer;
        float: right;
    }
    .close:hover {
        font-weight: bold;
    }
  
    @media only screen and (max-width: 767px) {
        .orderMgt {
            background: rgb(0, 0, 0);
            background: rgba(0, 0, 0, 0.6);
            position: fixed;
            width: 98%;
            height: 100%;
            top: 0;
            left: 0;

            padding: 3rem 1%;
            display: flex;
            flex-direction: column;
        }
        
        .textbox {
            padding-top: -10px;
            margin-top: -10px;
            min-width: 320px;
        }
    }
</style>